import {NgModule} from '@angular/core';
import {FileComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {IconComponentModule} from '../../ui/icon/item.module';
import {FileItemsComponentModule} from '../../ui/file-items/item.module';
import {ButtonComponentModule} from '../../ui/button/item.module';
import {ModalFooterComponentModule} from '../../ui/modal-footer/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        IconComponentModule,
        FileItemsComponentModule,
        ButtonComponentModule,
        ModalFooterComponentModule
    ],
  exports: [
    FileComponent
  ],
  declarations: [FileComponent],
  providers: [],
})
export class FileComponentModule {
}
